import { useQuery } from "react-query";
import { getUsageData } from "api/usage";
import DetailCard from "components/detail-card";
import ShimmerLoader from "components/shimmer-loader";
import getFormattedDate from "utils/methods/getFormattedDate";
import { ReactComponent as NotesIcon } from "assets/svgs/notes.svg";
import { ReactComponent as PatientIcon } from "assets/svgs/patient.svg";
import { ReactComponent as TemplateIcon } from "assets/svgs/template.svg";

const Usage = () => {
  const { data, isLoading } = useQuery("userUsage", getUsageData, {
    retry: false,
    staleTime: 10000,
  });

  const getDefaultTextIfAbsent = (envVal) => {
    if (!envVal || envVal === undefined) {
      return "";
    }
    return ` of ${envVal}`;
  };

  return (
    <div className="flex flex-wrap gap-10 mt-11 mb-14 xl:max-w-[850px]">
      <DetailCard className={"flex flex-col px-4 py-3"}>
        <div className="h-12 mb-2">
          <PatientIcon />
        </div>
        <span className="text-base text-grey">Patient Sessions</span>
        {isLoading ? (
          <ShimmerLoader className="w-8 h-8" />
        ) : (
          <>
            <span className="text-base h-8">
              {data?.sessions || 0}
              {data?.isFreeTrial
                ? `${getDefaultTextIfAbsent(
                    process.env.REACT_APP_TRIAL_USER_LIMIT_SESSIONS || 60
                  )}`
                : ""}
            </span>
            {data?.isFreeTrial && data?.nextResetDate && (
              <span className="text-xs text-grey block mt-0.5">
                Resets {getFormattedDate(data.nextResetDate)}
              </span>
            )}
          </>
        )}
      </DetailCard>
      <DetailCard className={"flex flex-col px-4 py-3"}>
        <div className="h-12 mb-2">
          <NotesIcon />
        </div>
        <span className="text-base text-grey">Total Notes Created</span>
        {isLoading ? (
          <ShimmerLoader className="w-8 h-8" />
        ) : (
          <span className="text-base h-8">
            {data?.notes || 0}
          </span>
        )}
      </DetailCard>
    </div>
  );
};

export default Usage;